module.exports = {
	"base": {
		"welcome": "¡Bienvenido a Mulligans, %{name}!",
		"user": "Información del usuario",
		"devices": "Dispositivos",
		"refunds": "Reembolsos",
		"resources": "Recursos",
		"transactions": "Pedidos y devoluciones",
		"email": "Correo electrónico",
		"password": "Contraseña",
		"save": "Guardar",
		"sign-out": "Cerrar sesión",
		"cancel": "Cancelar",
		"close": "Cerrar",
		"learn-more": "Más información",
		"required": "Requerido",
		"support": "Asistencia técnica",
		"bookshelf": "Librería",
		"launch": "Ejecutar",
		"download": "Descargar",
		"details": "Detalles",
		"cannot-be-blank": "%{field} no puede estar en blanco.",
		"saving": "Guardando...",
		"done": "Realizado",
		"failed": "Error",
		"copy": "Copiar"
	},
	"signin": {
		"login-failure": "El correo electrónico o la contraseña son incorrectos",
		"welcome-large": "Bienvenido al <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Identificarse",
		"forgot-password": "Olvidó su contraseña",
		"new-to-vst": "¿Eres nuevo en %{brand}?",
		"create-account": "Cree una cuenta",
		"signing-in": "Iniciando sesión...",
		"signin-failed": "Falló inicio de sesión"
	},
	"transactions": {
		"price": "Precio",
		"excluded": "(Excluyendo impuestos)",
		"quantity": "Cantidad",
		"confirmation#": "No. de confirmación",
		"payment": "Pago",
		"purchased": "Adquirido",
		"purchase-details": "Detalles de la compra",
		"subtotal": "Subtotal",
		"total": "Total",
		"tax": "Impuesto",
		"loading": "¡Hola! Estamos cargando sus transacciones...",
		"no-purchases": "No tiene compras.",
		"seller-vat": "IVA del vendedor",
		"total-vat": "Total %{vat} pagado",
		"portion": "%{subTax} Impuesto %{rate}%",
		"vat-disclosure": "El precio incluye %{vat}",
		"purchases": "Compras",
		"refunded-items": "Elementos con reembolso",
		"book-title": "Título del libro",
		"refund-details": "Detalles del reembolso",
		"print-receipt": "Imprimir recibo",
		"request-refund": "Solicitar reembolso",
		"expired": "Caducado",
		"expires-in": "Caduca el %{date}",
		"details-refund": "Detalles y reembolso",
		"modal": {
			"cant-refund-title": "Reembolso no disponible",
			"cant-refund": "No se puede reembolsar su libro por una o más de las siguientes razones:",
			"cant-refund-1": "Se ha consultado una porción demasiado extensa de su libro.",
			"cant-refund-2": "Han pasado más de 14 días desde la fecha de compra.",
			"cant-refund-3": "Su código de recursos en línea se reveló.",
			"cant-refund-4": "Su libro se reembolsó anteriormente.",
			"cant-refund-5": "Todos los códigos se han canjeado o reembolsado.",
			"cant-refund-6": "Han pasado más de 30 días desde la fecha de compra.",
			"cant-refund-support": "Si aún no conoces bien la política de reembolso de %{brand}, contacta a <a href='%{support_url}' target='_blank'>Asistencia Técnica</a>."
		},
		"license": {
			"perpetual": "El acceso en línea no caduca",
			"days": "Acceso por %{days} días"
		}
	},
	"devices": {
		"description": "%{brand} te permite tener <span>%{desktop}</span> computadoras y <span>%{mobile}</span> dispositivos móviles/tabletas activados en un momento dado.",
		"loading": "Bien, estamos reconociendo sus dispositivos :)",
		"no-active": "No tiene dispositivos activos.",
		"deactivate": "Desactivar"
	},
	"user": {
		"personal-information": "Información personal",
		"security-information": "Informacion de seguridad",
		"notifications": "Notificaciones",
		"first-name": "Nombre",
		"last-name": "Apellido",
		"change-password-title": "Cambiar contraseña",
		"current-password": "Contraseña actual",
		"new-password": "Nueva contraseña",
		"security-password": "Contraseña",
		"confirm-new-password": "Confirmar contraseña",
		"security-question": "Pregunta de seguridad",
		"security-info-change": "Cambiar",
		"question": "Pregunta",
		"answer": "Respuesta",
		"notifications-text": "Enviarme por correo electrónico actualizaciones ocasionales sobre la actividad de mi cuenta, actualizaciones de productos y ofertas especiales.",
		"loading": "Spot está buscando su información de usuario. Un segundo 🐶",
		"change-password-text": "La contraseña debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un carácter especial.",
		"email-locked": "Correo electrónico bloqueado ",
		"email-locked-description": "Usted no tiene acceso para cambiar su correo electrónico.",
		"email-locked-more": "Por favor, comuníquese con su administrador.",
		"security-question6": "¿Cuál es su deporte favorito?",
		"security-question7": "¿Cuál es su sabor de helado favorito?",
		"security-question8": "¿Cuál es el nombre de su mascota favorita?",
		"security-question9": "Cuando era joven, ¿qué quería ser cuando fuera grande?",
		"security-question10": "¿Cuál era el apellido de su profesor favorito?",
		"new-password-failure": "La contraseña no cumple con los requisitos",
		"confirm-password-failure": "La contraseña debe coincidir",
		"new-password-tooltip": "Debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un carácter especial.",
		"enter-valid-email": "Introduzca un correo electrónico válido.",
		"password-cannot-be-same": "La contraseña no puede ser igual a la contraseña anterior",
		"incorrect-password": "Contraseña incorrecta",
		"complete-account": "Parece que necesitas <a href='%{href}'>completar tu cuenta</a>.",
		"completing-allows": "Completar tu cuenta te permite leer libros fuera de línea en nuestras aplicaciones móviles y compartir notas y resaltados con amigos.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Auxiliares",
		"access-codes": "Códigos de acceso",
		"print-on-demand": "Imprimir a solicitud",
		"check-pod": "Verifica las opciones de impresión de la editorial de tus libros.",
		"check-now": "Verificar ahora",
		"loading": "Un momento, ¡estamos actualizando sus recursos!",
		"in": "en",
		"access-code-intro": "Un código de acceso es una contraseña que se utiliza para acceder al contenido del curso en línea. Una vez que revela un código de un elemento, no podrá regresarlo. Para ver más instrucciones sobre cómo usar sus códigos, visite <a href='%{support_url}' target='_blank'>Asistencia técnica</a>.",
		"expires": "Caduca",
		"expiration-message": "Contiene instrucciones para utilizar el código de acceso.",
		"copy-fail": "No se puede copiar. Seleccione el código y cópielo manualmente.",
		"launch-site": "Ejecutar el sitio",
		"launch-book": "Ejecutar libro",
		"reveal-code": "Revelar código",
		"no-resources": "No tiene ningún recurso.",
		"no-access-codes": "No tiene ningún código de acceso.",
		"no-ancillaries": "No hay elementos auxiliares para este título",
		"name": "Nombre",
		"type": "Tipo",
		"size": "Tamaño",
		"download-all": "Descargar todo",
		"back": "Volver a recursos"
	},
	"refunds": {
		"states": {
			"refunded": "Reembolsado",
			"unavailable": "Reembolso no disponible"
		},
		"reasons": {
			"dropped": "Abandoné el curso",
			"wrong": "Este libro no era apropiado para mi curso",
			"print": "En su lugar, decidí comprar una versión impresa",
			"missing": "El libro no contiene todo lo que necesito para mi curso (por ejemplo, un CD, acceso a la web, videos)",
			"other": "Otro"
		},
		"bulk": {
			"policy": "Al hacer clic en el botón &quot;Completar reembolso&quot; abajo, acepto la política de reembolso de %{brand} <a href='%{policy_url}' target='_blank'>.</a> ",
			"complete": "Completar reembolso",
			"view-details": "Ver detalles del reembolso",
			"success": "Se solicitó tu reembolso. El trámite puede tardar 48 horas.",
			"failure": "Lo sentimos. Hubo un problema. Lamentablemente, no se pudo realizar su reembolso.",
			"retry": "Volver a intentar",
			"support": "Contactar la Asistencia Técnica",
			"available-codes": "Códigos disponibles",
			"codes-selected": "Códigos seleccionados",
			"download": "Descargar códigos",
			"partially-refunded": "Parcialmente reembolsado",
			"pick-one": "Debe seleccionar por lo menos un código para hacer un reembolso"
		},
		"refund": "Reembolso",
		"all": "¿Reembolsar todo?",
		"missing-reason": "Debe seleccionar una razón para continuar",
		"missing-elaboration": "Sírvase proporcionar más detalles",
		"policy": "Al hacer clic en el botón “Completar solicitud de reembolso” abajo, entiendo que si compro este eTextbook de %{brand} nuevamente, no seré elegible para solicitar cualquier reembolso por el mismo eTextbook. Ver la política de reembolso completa.",
		"refunded": "Reembolsado",
		"sorry": "Lamentamos que no se sienta satisfecho con su compra.",
		"error": "Hubo un problema",
		"error-explain": "No podemos procesar su reembolso. Intente más tarde.",
		"why": "Cuéntenos el motivo.",
		"no-refunds": "No tiene elementos reembolsados.",
		"select-codes": "Seleccionar código(s) para reembolsar:",
		"number": "¿Cuántos?",
		"back": "Volver a reembolsos"
	},
	"purchases": {
		"back": "Volver a compras"
	},
	"global-bar": {
		"account": "Configuración de la Cuenta"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/es-MX.json
 ** module id = 978
 ** module chunks = 0
 **/